import React from 'react';
import { PopoverNavigationItem, cssColorValue, semanticColors } from '@spotify-internal/encore-web/core';
import styled, { css } from 'styled-components';

import { NavBarPopoverList, NavBarPopoverListTitle } from 'components/Masthead/Header/Popover/Shared';
import { MastheadLink, MastheadLinkList } from 'lib/sanity/types';
import { NavBarPopoverListItem } from 'components/Masthead/Header/Popover/LinkItem';
import { isLinkDisabled, isLinkVisible } from 'components/Masthead/shared/utils';
import { MastheadContainer } from 'components/Masthead/Header/types';

interface Props {
  container?: MastheadContainer;
  isLoggedIn: boolean;
  linkListEntry: MastheadLinkList;
  onClick?: (link: MastheadLink) => void;
}

const sideMenuVariantStyles = css`
  background-color: ${cssColorValue(semanticColors.backgroundTintedBase)};
  border-radius: 8px;
  padding: 8px 12px;
`;

const StyledPopoverNavigationItem = styled(PopoverNavigationItem)<{
  container: MastheadContainer;
}>`
  ${({ container }) => container === 'sidemenu' && sideMenuVariantStyles}
`;

export const NavbarPopoverItem = ({
  container = 'header',
  isLoggedIn,
  linkListEntry: { label, entries },
  onClick,
}: Props) => {
  return (
    <StyledPopoverNavigationItem container={container}>
      <NavBarPopoverListTitle>{label}</NavBarPopoverListTitle>
      <NavBarPopoverList>
        {entries
          .filter(({ link }) => isLinkVisible(link, isLoggedIn))
          .map(({ link, nestingLevel, _key }) => (
            <NavBarPopoverListItem
              {...link}
              key={_key}
              isDisabled={isLinkDisabled(link, isLoggedIn)}
              nestingLevel={nestingLevel}
              onClick={() => {
                if (onClick) {
                  onClick(link);
                }
              }}
            />
          ))}
      </NavBarPopoverList>
    </StyledPopoverNavigationItem>
  );
};
